import React, { useRef, useEffect, useState } from 'react';
import {extend, useFrame, useThree } from '@react-three/fiber';
import {DoubleSide } from 'three';
import * as THREE from 'three';
// import { GUI } from 'dat.gui';
import { cleanLoadTexture } from 'utils/textureHelper';
import { DragControls } from 'three/examples/jsm/controls/DragControls';

extend({ DragControls });

const ShapeRow = ({ initialPosition, initialRotation, initialScale, config }) => {
  const meshRef = useRef();
  const [texture, setTexture] = useState(null);
  const { raycaster} = useThree();
  const [, setIsHovered] = useState(false);
  const [imageData, setImageData] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    cleanLoadTexture(config.url).then(setTexture);
  }, [config]);

  useEffect(() => {
    const img = new Image();
    img.src = config.url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      setImageData(ctx.getImageData(0, 0, img.width, img.height).data);
    };
  }, [config.url]);

  useEffect(() => {
    if (meshRef.current) {
      const position = new THREE.Vector3(...initialPosition);
      meshRef.current.position.copy(position);
      meshRef.current.rotation.set(...initialRotation);
      meshRef.current.scale.set(...initialScale);
    }
  }, [initialPosition, initialRotation, initialScale]);

  useFrame(({ camera, mouse }) => {
    if (meshRef.current && imageData) {
      raycaster.setFromCamera(mouse, camera);
      const intersects = raycaster.intersectObject(meshRef.current);

      let isHoveredItem = false
      if (intersects.length > 0) {
        const intersect = intersects[0];
        const uv = intersect.uv;
        const uvX = Math.floor(uv.x * texture?.image.width);
        const uvY = Math.floor(uv.y * texture?.image.height);
        const index = (uvY * texture?.image.width + uvX) * 4;
        const alpha = imageData[index + 3];
        if (alpha > 0) {
          isHoveredItem = true;
        }
      }

      setIsHovered(isHoveredItem);
      setVisible(isHoveredItem);
    }
  });

  return (
    <mesh
      ref={meshRef}
      renderOrder={1} 
      visible={visible}
    >
      <planeGeometry args={[5, 2]} />
      <meshPhongMaterial
        map={texture}
        side={DoubleSide}
        transparent
      />
    </mesh>
  );
};

export default ShapeRow;

// import React, { useRef, useEffect, useState } from 'react';
// import { useThree, useFrame, extend } from '@react-three/fiber';
// import { TextureLoader, DoubleSide, Vector3, Euler } from 'three';
// import * as THREE from 'three';
// import { GUI } from 'dat.gui';
// import { DragControls } from 'three/examples/jsm/controls/DragControls';
// import { cleanLoadTexture } from 'utils/textureHelper';

// extend({ DragControls });

// const ShapeRow = ({ visible, initialPosition, initialRotation, initialScale, config }) => {
//   const meshRef = useRef();
//   const [texture, setTexture] = useState(null);
//   const [selected, setSelected] = useState(false);
//   const { raycaster, camera, gl } = useThree();
//   const [isHovered, setIsHovered] = useState(false);
//   const [imageData, setImageData] = useState(null);
//   const [lookAtCamera, setLookAtCamera] = useState(config.lookAtCamera || false);
//   const [mouse, setMouse] = useState({ x: 0, y: 0 });
//   const guiRef = useRef(null);
//   let posXControl, posYControl, posZControl;

//   useEffect(() => {
//     cleanLoadTexture(config.url).then(setTexture);
//   }, [config]);

//   useEffect(() => {
//     const img = new Image();
//     img.src = config.url;
//     img.onload = () => {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(img, 0, 0);
//       setImageData(ctx.getImageData(0, 0, img.width, img.height).data);
//     };
//   }, [config.url]);

//   useEffect(() => {
//     if (meshRef.current) {
//       const position = new Vector3(...initialPosition);
//       const rotation = new Euler(...initialRotation);

//       meshRef.current.position.copy(position);
//       meshRef.current.rotation.copy(rotation);
//       meshRef.current.scale.set(...initialScale);
//       meshRef.current.visible = visible;
//     }
//   }, [initialPosition, initialRotation, initialScale, visible]);

//   useEffect(() => {
//     if (selected && meshRef.current) {
//       const gui = new GUI();
//       guiRef.current = gui;
  
//       const itemFolder = gui.addFolder('Rotation');
//       itemFolder.add(meshRef.current.rotation, 'x', -5, Math.PI * 2);
//       itemFolder.add(meshRef.current.rotation, 'y', -5, Math.PI * 2);
//       itemFolder.add(meshRef.current.rotation, 'z', -5, Math.PI * 2);
  
//       // Custom object for xz rotation
//       const rotationXZ = {
//         x: meshRef.current.rotation.x,
//         z: meshRef.current.rotation.z,
//       };
  
//       itemFolder.add(rotationXZ, 'x', -5, Math.PI * 2).onChange((value) => {
//         meshRef.current.rotation.x = value;
//       });
//       itemFolder.add(rotationXZ, 'z', -5, Math.PI * 2).onChange((value) => {
//         meshRef.current.rotation.z = value;
//       });
  
//       itemFolder.open();
  
//       const cameraFolder = gui.addFolder('Position');
//       posXControl = cameraFolder.add(meshRef.current.position, 'x', -1000, 1000);
//       posYControl = cameraFolder.add(meshRef.current.position, 'y', -1000, 1000);
//       posZControl = cameraFolder.add(meshRef.current.position, 'z', -1000, 1000);
//       cameraFolder.open();
  
//       const scaleFolder = gui.addFolder('Scale');
//       scaleFolder.add(meshRef.current.scale, 'x', 0, 500);
//       scaleFolder.add(meshRef.current.scale, 'y', 0, 500);
//       scaleFolder.open();
  
//       const opacityFolder = gui.addFolder('Opacity');
//       opacityFolder.add(meshRef.current.material, 'opacity', 0.195, 0.5);
//       opacityFolder.open();

//       const lookAtCameraFolder = gui.addFolder('Look At Camera');
//       lookAtCameraFolder.add({ lookAtCamera }, 'lookAtCamera').onChange(setLookAtCamera);
//       lookAtCameraFolder.open();
  
//       return () => {
//         gui.destroy();
//         guiRef.current = null;
//       };
//     } else if (guiRef.current) {
//       guiRef.current.destroy();
//       guiRef.current = null;
//     }
//   }, [selected, lookAtCamera]);

//   useEffect(() => {
//     if (selected && meshRef.current) {
//       const handleControlUpdate = () => {
//         config.initialPosition = [meshRef.current.position.x, meshRef.current.position.y, meshRef.current.position.z];
//         config.initialRotation = [meshRef.current.rotation.x, meshRef.current.rotation.y, meshRef.current.rotation.z];
//       };

//       const controls = new DragControls([meshRef.current], camera, gl.domElement);
//       controls.addEventListener('dragend', handleControlUpdate);

//       return () => {
//         controls.removeEventListener('dragend', handleControlUpdate);
//         controls.dispose();
//       };
//     }
//   }, [selected, camera, gl.domElement, config]);

//   useEffect(() => {
//     const handleMouseMove = (event) => {
//       setMouse({
//         x: (event.clientX / window.innerWidth) * 2 - 1,
//         y: -(event.clientY / window.innerHeight) * 2 + 1,
//       });
//     };

//     window.addEventListener('mousemove', handleMouseMove);

//     return () => {
//       window.removeEventListener('mousemove', handleMouseMove);
//     };
//   }, []);

//   useFrame(({ camera }) => {
//     if (meshRef.current && lookAtCamera) {
//       meshRef.current.lookAt(camera.position);
//     }

//     if (meshRef.current && imageData) {
//       raycaster.setFromCamera(mouse, camera);
//       const intersects = raycaster.intersectObject(meshRef.current);

//       let isHoveredItem = false;
//       if (intersects.length > 0) {
//         const intersect = intersects[0];
//         const uv = intersect.uv;
//         const uvX = Math.floor(uv.x * texture?.image.width);
//         const uvY = Math.floor(uv.y * texture?.image.height);
//         const index = (uvY * texture?.image.width + uvX) * 4;
//         const alpha = imageData[index + 3];
//         if (alpha > 0) {
//           isHoveredItem = true;
//         }
//       }

//       setIsHovered(isHoveredItem);
//     }
//   });

//   return (
//     <mesh
//       ref={meshRef}
//       visible={visible && isHovered}
//       renderOrder={1}
//       userData={{ isShapeRow: true, id: config.id }}
//       onClick={() => setSelected(!selected)}
//     >
//       <planeGeometry args={[5, 2]} />
//       <meshPhongMaterial
//         color="white"
//         map={texture}
//         alphaTest={0.1}
//         side={DoubleSide}
//         transparent
//         opacity={1.1}
//       />
//     </mesh>
//   );
// };

// export default ShapeRow;
